var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgView24 = function SvgView24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 4a4 4 0 1 0 0 7.999A4 4 0 0 0 10 4Zm-2 4a2 2 0 1 1 4-.002A2 2 0 0 1 8 8Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.24 1.001A9.478 9.478 0 0 0 1.874 4.603L.656 6.63a2.66 2.66 0 0 0 0 2.738l1.218 2.028a9.48 9.48 0 0 0 16.255 0l1.217-2.028a2.66 2.66 0 0 0 0-2.738L18.13 4.603A9.479 9.479 0 0 0 14.24 1Zm-7.583 1.79a7.479 7.479 0 0 1 9.757 2.84l1.217 2.03a.66.66 0 0 1 0 .679l-1.217 2.028a7.48 7.48 0 0 1-12.825 0L2.37 8.34a.66.66 0 0 1 0-.68L3.59 5.632A7.479 7.479 0 0 1 6.657 2.79Z",
    fill: "#242424"
  })));
};
export default SvgView24;